import { VolumeVoiceDetector } from "@service/voice-detection/volume-voice-detector";
import { AiVoiceDetector } from "@service/voice-detection/ai-voice-detector";
import {
  VoiceDetector,
  VoiceDetectorOptions,
} from "@service/voice-detection/voice-detector";

enum VoiceDetectorType {
  volume = "volume",
  ai = "ai",
}

export class VoiceDetectorFactory {
  public static create(options: VoiceDetectorOptions): VoiceDetector {
    switch (process.env.REACT_APP_VOICE_DETECTOR_TYPE as VoiceDetectorType) {
      case VoiceDetectorType.volume: {
        return new VolumeVoiceDetector(options);
      }
      case VoiceDetectorType.ai:
      default: {
        return new AiVoiceDetector(options);
      }
    }
  }
}
